import { ReactNode } from 'react';

import { isSSG } from 'modules/common/utils/isSSG';

export interface NoSSRGuardProps {
  children: ReactNode;
  fallback?: ReactNode;
}

export const NoSSRGuard = ({ children, fallback = null }: NoSSRGuardProps) => {
  return isSSG() ? fallback : <>{children}</>;
};
